module.exports = __webpack_public_path__ + "img/Quick-Visit-Is-Nice.aa89e927.jpg";